// extracted by mini-css-extract-plugin
module.exports = {"history":"History_history__CBe-k","number":"History_number__30zhf"};